import {AnimatronProjectsFactory} from '../services/AnimatronProjectsSvc';
import {FollowersSvcFactory} from '../services/FollowersSvc';
import {HttpSvcFactory} from '../services/HttpSvc';
import {AdSvc} from 'services/AdSvc';
import {Utils} from 'underscore-extensions';
import {Strings} from 'Strings';

class UserCtrl implements ng.IComponentController {
    tabs = ['your', 'contest', 'join', 'init'];

    currentTab: string = this.$stateParams.page || this.tabs[0];

    userNotFound: boolean;

    constructor(private $scope: any,
                private $rootScope: ng.IRootScopeService,
                private $stateParams: any,
                private $state: ng.ui.IStateService,
                private FollowersSvc: FollowersSvcFactory,
                private $filter: ng.IFilterService,
                private HttpSvc: HttpSvcFactory,
                private AnimatronProjects: AnimatronProjectsFactory) {
        $scope.AdSvc = new AdSvc(false, this.$rootScope);
        $scope.enableProfileProject = true;
        $scope.sameUser = Strings.sameUser($stateParams.username);

        const subjectUser = $filter('encodeUsername')($stateParams.username);
        const adify = this.$scope.AdSvc.adify.bind(this.$scope.AdSvc);
        if ($scope.sameUser) {
            const state: 'ACTIVE' | 'REMOVED' = this.$stateParams.removed ? 'REMOVED' : 'ACTIVE';
            $scope.animatron = new AnimatronProjects({state}, true, '', adify);
            this.load(options.user);
        } else {
            $scope.animatron = new AnimatronProjects({username: subjectUser}, false, '', adify);
            $scope.animatronUser = $scope.animatron.projectsAuthor = $stateParams.user;
            HttpSvc(subjectUser, 'profile').get().then(r => r.data).then((response: ApiError | anm.User) => {
                if (Utils.isUser(response)) {
                    this.load(response);
                } else {
                    this.userNotFound = true;
                    document.head.querySelector('[name=robots]').content = 'noindex';
                    document.head.querySelector('[name=prerender-status-code]').content = '404';
                }
            });
        }
    }

    load(user: anm.User) {
        this.$rootScope.setTitle('user.title', user.displayName);
        if (!this.$scope.sameUser) {
            this.$scope.animatronUser = this.$scope.animatron.projectsAuthor = user;
        } else {
            this.$scope.$watch(() => options.user, (val: anm.User) =>
                this.$scope.animatron.projectsAuthor = this.$scope.animatronUser = val
            );
        }

        this.$scope.followersSvc = new this.FollowersSvc(this.$scope.sameUser, 'studio-following');
    }

    onTabChange(tab: string) {
        const page = tab === 'your' ? null : tab;
        this.$state.go('.', {page}, {notify: false});
        if (tab === 'your') {
            this.$rootScope.$emit('masonry:layout');
        }
    }
}

angular.module('animatronApp.profileProject').component('userPage', {
    controllerAs: 'UserCtrl',
    controller: UserCtrl,
    templateUrl: require('user-page.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/UserPage.ts